import styled from '@emotion/styled'

export const StyledFooter = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`
